export default "__VITE_ASSET__DGUB6sxh__"